export default "__VITE_ASSET__BAduOj6n__"